// extracted by css-extract-rspack-plugin
export default {"root":"iljCI4sc5xIUayGS","dense":"v_rnEfgWDgl6adYJ","autoHeight":"WyRx8Vx4Sn0O7g3a"};